import { add, compose, evolve, filter, length, map, multiply, path, pathOr, propEq, reduce, trim } from 'ramda'

const getEntities = path(['entities'])
const countLinesByValidFlag = (valid) => compose(length, filter(propEq('valid', valid)), getEntities)

/**
 * Basket import line module getters.
 */
export default {
  /**
   * Counts the number of lines in the store.
   *
   * @param {Object} state
   * @return {Number}
   */
  lineCount: compose(length, getEntities),

  /**
   * Counts the number of valid lines in the state.
   *
   * @param {Object} state
   * @return {Number}
   */
  validLineCount: countLinesByValidFlag(true),

  /**
   * Counts the number of invalid lines in the state.
   *
   * @param {Object} state
   * @return {Number}
   */
  invalidLineCount: countLinesByValidFlag(false),

  /**
   * Counts the number of lines where the unit quantity has been changed.
   *
   * @param {Object} state
   * @return {Number}
   */
  amendedQuantityLineCount: compose(
    length,
    filter((line) => line.originalQuantity !== line.correctedQuantity),
    map(evolve({ originalQuantity: compose(Number, trim) })),
    filter(propEq('valid', true)),
    getEntities,
  ),

  /**
   * Gets the total value of the import.
   *
   * This multiplies the value per line by the corrected quantity and then sums all.
   *
   * @param {Object} state
   * @returns {Number}
   */
  importTotalValue: compose(
    reduce(add, 0),
    map((line) => multiply(
      path(['correctedQuantity'], line),
      compose(Number, path(['unitPrice', 'value']))(line),
    )),
    filter((line) => path(['valid'], line) && path(['correctedQuantity'], line)),
    getEntities,
  ),

  /**
   * Gets the currency of the import.
   *
   * @param {Object} state
   * @return {String|null}
   */
  importCurrency: compose(
    reduce((carry, line) => carry || pathOr(null, ['unitPrice', 'baseCurrency'], line), null),
    getEntities,
  ),
}
